module.exports = __webpack_public_path__ + "static/img/wagoPic.8364b30.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/wagoPic.jpg
// module id = 9H58
// module chunks = 1